import React from 'react';
import { certifications } from '../../portfolio';
import { ExternalLink } from 'lucide-react';

const Certifications = () => {
  return (
    <section className="section">
      <div className="section-header">
        <h1 className="section-title">Certifications</h1>
        <p className="section-subtitle">Professional credentials and verified achievements.</p>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 320px), 1fr))', gap: '24px' }}>
        {certifications.map((cert, idx) => (
          <a href={cert.livePreview} target="_blank" rel="noopener noreferrer" key={idx} className="list-card" style={{ padding: '32px 24px', background: 'var(--surface)', borderRadius: 'var(--radius)', border: '1px solid var(--border)', textDecoration: 'none', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', transition: 'background 0.2s', ':hover': {background: 'var(--surface-hover)'} }}>
            <div>
              <h4 style={{ fontSize: '16px', fontWeight: 600, color: 'var(--text-1)', marginBottom: '12px', lineHeight: 1.5 }}>{cert.name}</h4>
              <p style={{ fontSize: '14px', color: 'var(--text-2)', lineHeight: 1.6 }}>{cert.description}</p>
            </div>
            <div style={{ marginTop: '32px', display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', color: 'var(--text-3)', fontWeight: 500 }}>
              Verify Credential <ExternalLink size={14} />
            </div>
          </a>
        ))}
      </div>
    </section>
  );
};

export default Certifications;
